import { R } from '@utils/currency'

export const totalBudgetExpensesAtAgeFromJointForecast = (jointForecast, age, { clientKey }) => {
  const clientForecast = jointForecast?.client_forecasts[clientKey]

  const dataPointAtAge = clientForecast?.find((datapoint) => datapoint.age === age)
  const expenseBreakdown = dataPointAtAge?.expense_breakdown

  return R(expenseBreakdown?.monthly_budget_nominal).value || 0
}
